<div class="multiline-tag-input-container">
  <div class="mds-text--medium-normal mds-neutral__text-color m-b-4">{{ label }}</div>
  <div #dummyTextarea tagindex="1" class="dummy-textarea" [class.error]="inputInError" [ngStyle]="{ height: heightInPixels + 'px' }">
    <div class="tag-container">
      @for (tag of arraryOfTags(); track tag) {
        <mc-tag class="tags" withaction (dismiss)="onTagCloseClicked($index)">{{ tag }}</mc-tag>
      }
      <input
        [(ngModel)]="inputValue"
        [placeholder]="arraryOfTags().length === 0 ? placeholder : ''"
        class="actual-input"
        (blur)="onBlur($event)"
        (keydown.enter)="onEnterPressed($event)"
        (keydown.backspace)="onBackspace($event)"
        (keyup)="onKeyUp($event)"
        (paste)="onContentPasted($event)"
        (keydown.arrowup)="arrowKeyPressed()"
        (keydown.down)="arrowKeyPressed()" />
    </div>
  </div>
  @if (arraryOfTags().length > 0) {
    <div class="mds-text--x-small-normal mds-neutral--weak__text-color">{{ arraryOfTags().length }} items</div>
  }
  @if (inputInError) {
    <div class="mds-error__text-color mds-text--medium-normal">
      {{ allowDuplicates ? 'Invalid input' : 'Invalid input' }}
    </div>
  }
  @if (invalidContentPasted()) {
    <div class="mds-warning__text-color mds-text--medium-normal">No valid data found in pasted content</div>
  }
</div>
